var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mainmenu"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_c('li',[_c('router-link',{attrs:{"to":"/portfolio"}},[_vm._v("Portfolio")])],1),_c('li',[_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }